var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiechartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 25.0013C17.2501 25.0013 15.0001 22.7513 15.0001 20.0013C15.0001 17.2513 17.2501 15.0013 20.0001 15.0013V4.16797C11.2501 4.16797 4.16675 11.2513 4.16675 20.0013C4.16675 28.7513 11.2501 35.8346 20.0001 35.8346C23.6667 35.8346 27.0834 34.5846 29.8334 32.418L23.1667 23.918C22.2501 24.5846 21.1667 25.0013 20.0001 25.0013Z",
    fill: "#00BCD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.0013H35.8333C35.8333 11.2513 28.75 4.16797 20 4.16797V15.0013C22.75 15.0013 25 17.2513 25 20.0013Z",
    fill: "#448AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8333 20H24.9999C24.9999 21.5833 24.2499 23 23.0833 23.9167L29.7499 32.4167C33.4999 29.5 35.8333 25 35.8333 20Z",
    fill: "#3F51B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiechartIcon);
export default __webpack_public_path__ + "static/media/piechartIcon.67dd4da5d2a82ffb020bd7d293f71e88.svg";
export { ForwardRef as ReactComponent };